// A full page navigation changes deployments; in-flight wallet reviews never
// switch their API underneath an already prepared transaction.
export function deploymentBase(pathname: string) {
  return pathname === '/legacy' || pathname.startsWith('/legacy/') ? '/legacy' : '';
}
export const stackBase = typeof window === 'undefined' ? '' : deploymentBase(window.location.pathname);
export function stackFetch(transport: typeof fetch, base = stackBase): typeof fetch {
  return (input, init) => {
    if (typeof input === 'string' && input.startsWith('/api/')) return transport(base + input, init);
    return transport(input, init);
  };
}
